import "./PreguntasTalles.css";

export const PreguntasTallesCamisas = () => {
  const camisas = [
    {
      icon: "A",
      name: "Ancho de hombro",
      S: "11 cm",
      M: "12 cm",
      L: "13 cm",
    },
    {
      icon: "B",
      name: "Contorno de pecho",
      S: "114 cm",
      M: "119 cm",
      L: "124 cm",
    },
    {
      icon: "C",
      name: "Contorno de cintura",
      S: "115 cm",
      M: "120 cm",
      L: "125 cm",
    },
    {
      icon: "D",
      name: "Contorno de cadera",
      S: "120 cm",
      M: "125 cm",
      L: "130 cm",
    },
    {
      icon: "E",
      name: "Largo de manga",
      S: "26 cm",
      M: "27 cm",
      L: "28 cm",
    },
    {
      icon: "F",
      name: "Largo de talle",
      S: "62 cm",
      M: "67 cm",
      L: "72 cm",
    },
  ];

  return (
    <table className="preguntas-item-content-talles">
      <thead>
        <tr>
          <th>Tabla de talles</th>
          <th>Talle S</th>
          <th>Talle M</th>
          <th>Talle L</th>
        </tr>
      </thead>
      <tbody>
        {camisas.map((file, index) => (
          <tr key={index}>
            <th>
              <div>
                <span>{file.icon}</span>
              </div>
              {file.name}
            </th>
            <td>{file.S}</td>
            <td>{file.M}</td>
            <td>{file.L}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
